import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const IndentIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "IndentIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M0,0H16V1H0ZM16,3H7V4h9ZM7,6h9V7H7Zm9,6H7v1h9ZM0,15H16v1H0ZM16,9H7v1h9ZM3.273,8,0,11V5Z" }) })));
IndentIcon.displayName = "IndentIcon";
